import React, {useState} from 'react';

import {CopyButton} from 'src/components/copy-button/copy-button';

import Button, {FlatButton} from '@pb/kit-component-button';
import {Dialog, DialogFooter, DialogHeader, DialogHole, DialogMain} from '@pb/kit-component-dialog-v2';
import Group, {Item} from '@pb/kit-component-group';
import {Icons, Sizes} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {Loading, Types} from '@pb/kit-component-loading';

type Props = {
    eventDescription: string,
    setEventDescription: (description: string) => void,
    onGenerating: boolean,
    onGenerateClick: () => void,
    onEventDescriptionGenerate?: (description: string) => void,
};

const EVENT_DESCRIPTION_PLACEHOLDER = 'Click the button below to generate an event description for the event.';

export const EventDescriptionGenerationView = (props: Props) => {
    const {
        eventDescription,
        setEventDescription,
        onGenerating,
        onGenerateClick,
        onEventDescriptionGenerate,
    } = props;

    const [shown, setShown] = useState(false);

    const onClose = () => {
        setEventDescription('');
        setShown(false);
    };

    const onApply = () => {
        if (onEventDescriptionGenerate) {
            onEventDescriptionGenerate(eventDescription);
            setShown(false);
        }
    };

    return (
        <Dialog
            setShown={setShown}
            shown={Boolean(shown)}
            anchor={({anchorRef, getAnchorProps}) => (
                <BasicIconButton
                    className="event-description-generation-tour"
                    ref={anchorRef}
                    {...getAnchorProps()}
                    iconProps={{type: Icons.SPARKLES, size: Sizes.Size_16}}
                />
            )}>
            <Group direction="v" justify="space-between" className="pb-m" style={{minWidth: 500}}>
                <DialogHeader onClose={onClose}>AI Assistant</DialogHeader>
                <DialogMain>
                    <DialogHole>
                        <Group direction="v" gap="m">
                            <Group>
                                <Item><strong>Generated Event Description:</strong></Item>
                                {onGenerating ? (
                                    <Loading fast={true} type={Types.ICON}/>
                                ) : null}
                            </Group>
                            <Item style={{minHeight: '3rem'}}>
                                {eventDescription ? (
                                    <Group>
                                        <Item>{eventDescription}</Item>
                                        <CopyButton textToCopy={eventDescription} size={Sizes.Size_12}/>
                                    </Group>
                                ) : (
                                    <Item>{EVENT_DESCRIPTION_PLACEHOLDER}</Item>
                                )}
                            </Item>
                        </Group>
                        <Group justify="end">
                            {onEventDescriptionGenerate ? (
                                <FlatButton
                                    disabled={!eventDescription || onGenerating}
                                    onClick={onApply}>
                                    Apply
                                </FlatButton>
                            ) : null}
                        </Group>
                    </DialogHole>
                </DialogMain>
                <DialogFooter>
                    <Button style={{width: '100%'}} variant="Type.SECONDARY" onClick={onGenerateClick}>
                        Generate Event Description
                    </Button>
                </DialogFooter>
            </Group>
        </Dialog>
    );
};
